import { Component, computed, input } from '@angular/core';
import { DatePipe } from '@angular/common';
import { RxIconModule } from '@nrwl/rx-icon';
import { SimpleTable } from './simple-table';
import { SimpleTableCellDef } from './simple-table-cell-def';
import { SimpleTableColumnDef } from './simple-table-column-def';
import { SimpleTableHeaderCellDef } from './simple-table-header-cell-def';
import { MedicalNoteItem } from './medical-note-item';
import { ScribeSuggestionIndicatorComponent } from '../shared/scribe-suggestion-indicator/scribe-suggestion-indicator.component';

/**
 * Print-only view for the Medical Notes widget used in generated documents.
 */
@Component({
  selector: 'fb-medical-notes-widget-print',
  imports: [
    SimpleTable,
    SimpleTableColumnDef,
    SimpleTableHeaderCellDef,
    SimpleTableCellDef,
    RxIconModule,
    DatePipe,
    ScribeSuggestionIndicatorComponent,
  ],
  templateUrl: './medical-notes-widget-print.html',
  styleUrl: './medical-notes-widget-print.scss',
})
export class MedicalNotesWidgetPrint {
  /**
   * Medical notes to be displayed.
   */
  public readonly data = input<readonly MedicalNoteItem[]>([]);
  public readonly isTemplatePrint = input(false);

  public readonly visibleNotes = computed(() => {
    if (this.isTemplatePrint()) {
      return this.data();
    }

    return this.data().filter((note) => this.isNoteMeaningful(note));
  });

  private isNoteMeaningful(note: MedicalNoteItem): boolean {
    const hasText = typeof note.text === 'string' && note.text.trim() !== '';
    const hasEmployee = typeof note.employeeId === 'string' && note.employeeId.trim() !== '';
    const hasDate = note.date instanceof Date && !Number.isNaN(note.date.getTime());

    return hasText || hasEmployee || hasDate;
  }
}
